import { Box, Stack, Typography } from "@mui/material";
import * as React from "react";
import Chart from "react-apexcharts";
export const DashboardChart = ({
  title,
  data,
  barColor,
  horizontal = false,
  index,
  width,
  xAxisKey = "x-axis",
  yAxisKey = "y-axis",
  barHeight = "41px",
  seriesName = "Orders",
  valueFormatter = (value) => "$" + value?.toFixed(2),
  xAxisLabelFormatter = (y) => y,
  yAxisOption = {},
}) => {
  const state = {
    options: {
      chart: {
        id: "basic-bar",
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        categories: data[xAxisKey],
        labels: {
          maxWidth: 50,
          rotate: -90,
          formatter: xAxisLabelFormatter,
        },
      },
      yaxis: {
        show: horizontal,
        ...yAxisOption,
      },
      grid: {
        show: false,
      },
      plotOptions: {
        bar: {
          barHeight,
          borderRadius: 8,
          borderRadiusApplication: "end",
          horizontal: horizontal,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -28,
        offsetX: 0,
        style: {
          fontSize: "14px",
          colors: [barColor],
        },
        formatter: valueFormatter,
      },
      colors: [barColor],
      tooltip: {
        marker: {
          show: false,
        },
      },
    },
    series: [
      {
        name: seriesName,
        data: data[yAxisKey],
      },
    ],
  };

  return (
    <Stack
      sx={{
        width: width,
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        gap: "16px",
        mb: "24px",
      }}
    >
      <Typography variant="subtitle2" fontWeight={600} p="24px">
        {title}
      </Typography>
      <Box
        sx={{
          width: "100%",
          overflowY: "hidden",
          overflowX: !horizontal ? "auto" : "hidden",
        }}
      >
        <Chart
          key={index}
          options={state.options}
          series={state.series}
          type="bar"
          width={!horizontal ? data[xAxisKey]?.length * 60 + 100 : "95%"}
          height={
            horizontal
              ? data[xAxisKey]?.length * 40 +
                (data[xAxisKey]?.length - 1) * 18 +
                90
              : "361px"
          }
        />
      </Box>
    </Stack>
  );
};
